var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgForumUserIcon = function SvgForumUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 13.5A3.75 3.75 0 1 0 12 6a3.75 3.75 0 0 0 0 7.5M12 15c-3.196 0-5.905 2.007-6.985 4.824A10.45 10.45 0 0 0 12 22.5c2.687 0 5.128-1.017 6.985-2.676C17.905 17.009 15.196 15 12 15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 24C5.384 24 0 18.616 0 12S5.384 0 12 0s12 5.384 12 12-5.384 12-12 12m0-21c-4.963 0-9 4.037-9 9 0 4.964 4.037 9 9 9 4.964 0 9-4.036 9-9 0-4.963-4.036-9-9-9"
  })));
};
export default SvgForumUserIcon;